import React from "react";
import { SvgProps } from "../../types";

// "#F6142D" - red

export const NotifyWarnIcon = (props: SvgProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 22 22"
      className={props.classNames?.join(" ") || ""}
    >
      <g clipPath="url(#clip0_130_6067)">
        <path
          d="M7.20498 1.83301H14.795L20.1666 7.20467V14.7947L14.795 20.1663H7.20498L1.83331 14.7947V7.20467L7.20498 1.83301Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 7.33301V10.9997"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 14.667H11.01"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs xmlns="http://www.w3.org/2000/svg">
        <clipPath id="clip0_130_6067">
          <rect width="22" height="22" fill="none" />
        </clipPath>
      </defs>
    </svg>
  );
};
